import store from "@/store";
import roles from "@/plugins/roles";

export const getRoles = () => {
  const { inn } = store.getters.getMyOrganisation;
  const role = store.getters.role;
  if (inn === "505203230884") {
    // роли для Щелкунова
    return [
      roles[0],
      roles[1],
      roles[2],
      roles[3],
      roles[4],
      roles[5],
      roles[6],
      roles[10],
    ];
  }
  let roleIndex = -1;
  for (let item in roles) {
    roles[item].role === role && (roleIndex = item);
  }
  if (roleIndex == 0 || (roleIndex >= 7 && roleIndex <= 9)) {
    //роли для просто комапний
    return [roles[0], roles[7], roles[8], roles[9]];
  } else if (roleIndex >= 11 && roleIndex <= 12) {
    return [roles[11], roles[12]];
  } else if (roleIndex >= 13 && roleIndex <= 14) {
    return [roles[13], roles[14]];
  } else if (roleIndex >= 15) {
    return roles;
  }
};
